// extracted by mini-css-extract-plugin
export default {"base":"base___E6lbj","cardNumber":"cardNumber___nXJjP","successTitle":"successTitle___ofQAZ"};